
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/en/legal/privacy-policy/joint-utilization",
      function () {
        return require("private-next-pages/en/legal/privacy-policy/joint-utilization.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/en/legal/privacy-policy/joint-utilization"])
      });
    }
  